// extracted by mini-css-extract-plugin
export default {"Times_Date":"Times_Times_Date__72DOB","Times_slots":"Times_Times_slots__pPUuo"};